import { createFileRoute, useLoaderData } from "@tanstack/react-router";

import { SEOHead, createOrganizationStructuredData } from "@/components/seo";
import { orgApiClient } from "@/libs/api/org-client";

import { OrgPage } from "./-components/org.page";

export const Route = createFileRoute("/org/$id")({
  component: () => Page(),
  loader: async ({ params }) => {
    const org = await orgApiClient.getOne(params.id);
    return { data: { org } };
  }
});

function Page() {
  const { data } = useLoaderData({ from: "/org/$id" });
  const { org } = data;
  if (!org) {
    return <div>Org not found</div>;
  }

  return (
    <>
      <SEOHead
        title={`${org.name} - Tổ chức sự kiện | Garther`}
        description={org.description || `Khám phá các sự kiện được tổ chức bởi ${org.name} trên Garther`}
        keywords={[org.name, "tổ chức", "organization", "sự kiện", "event", "garther"]}
        image={org.cover}
        url={`/org/${org.id}`}
        type="organization"
        structuredData={createOrganizationStructuredData({
          name: org.name,
          description: org.description || "",
          url: `https://garther.app/org/${org.id}`,
          image: org.cover
        })}
        canonical={`https://garther.app/org/${org.id}`}
      />
      <OrgPage org={org} />
    </>
  );
}
